import script from "./BuilderModalSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderModalSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderModalSkeleton.vue?vue&type=style&index=0&id=7815671a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7815671a"]])

export default __exports__